module.exports = __webpack_public_path__ + "img/no-goals-assigned.68f35c74.webp";